// Simple utility validator to check if the request response is a valid JSON object.
export default function isJson(item) {
    let value =
        typeof item !== "string" ?
            JSON.stringify(item) :
            item;

    try {
        value = JSON.parse(value);
    } catch (e) {
        return false;
    }

    return typeof value === "object" && value !== null;
}
